import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "reactstrap";
import { useGetFestivalOffer } from "../home/api/api";

const HomeAd = () => {
   const [modal, setModal] = useState(false);
   const [hasSeenBanner, setHasSeenBanner] = useState(() => {
      if (typeof window === 'undefined') return false;
      return localStorage.getItem('hasSeenFestivalOffer') === 'true';
   });
   const { data: getBanner } = useGetFestivalOffer({ type: "dashboard" });

   const activeBanner = getBanner?.data?.find(item => item.isActive === true) ?? null;
   useEffect(() => {
      const shouldShow = !!activeBanner && !hasSeenBanner;
      setModal(shouldShow);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [getBanner, hasSeenBanner]);

   const toggle = () => {
      setModal(false);
      setHasSeenBanner(true);
      if (typeof window !== 'undefined') {
         localStorage.setItem('hasSeenFestivalOffer', 'true');
      }
   };

   return (
      <Modal isOpen={modal} toggle={toggle} centered className="homeAd" backdropClassName='homeAdBkp' contentClassName='homeAdMdl'>
         <Link to={'/'} className="homeAdLk"></Link>
         <button className='btn homeAdCls' onClick={toggle}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M0.353516 0.353516L12.8535 12.8535M0.353516 12.8535L12.8535 0.353516" stroke="white" />
            </svg>
         </button>
         <div className="homeAdIg">
            <img src={activeBanner?.MobileUrl} alt="home-ad" className="img-fluid" />
         </div>
      </Modal>
   )
}
export default HomeAd;